import { defineCustomElement } from "vue";
import VCInput from "./VCInput.ce.vue";
import { Register } from "..";

const tag = "vc-input";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(VCInput));
  }
};

export default _register;
